import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10 16.667C13.6819 16.667 16.6667 13.6822 16.6667 10.0003C16.6667 6.31843 13.6819 3.33366 10 3.33366C6.31812 3.33366 3.33335 6.31843 3.33335 10.0003C3.33335 13.6822 6.31812 16.667 10 16.667ZM10 18.3337C14.6024 18.3337 18.3334 14.6027 18.3334 10.0003C18.3334 5.39795 14.6024 1.66699 10 1.66699C5.39765 1.66699 1.66669 5.39795 1.66669 10.0003C1.66669 14.6027 5.39765 18.3337 10 18.3337Z",
                fill: "#777E91"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 8.33301C10 7.87277 10.3731 7.49967 10.8334 7.49967H11.6667C12.1269 7.49967 12.5 7.12658 12.5 6.66634C12.5 6.20611 12.1269 5.83301 11.6667 5.83301H10.8334C9.4526 5.83301 8.33335 6.9523 8.33335 8.33301V9.99967H7.50002C7.03979 9.99967 6.66669 10.3728 6.66669 10.833C6.66669 11.2933 7.03978 11.6663 7.50002 11.6663H8.33335V16.6663C8.33335 17.1266 8.70644 17.4997 9.16669 17.4997C9.62694 17.4997 10 17.1266 10 16.6663V11.6663H11.6667C12.1269 11.6663 12.5 11.2933 12.5 10.833C12.5 10.3728 12.1269 9.99967 11.6667 9.99967H10V8.33301Z",
                fill: "#777E91"
            })
        ]
    }));
};
export default Icon;
